(function(){
    angular
        .module('appback')
        .directive('ngSimpleres', simpleres);

        simpleres.$inject = ['$timeout','GenerallabService'];
        function simpleres($timeout,GenerallabService){
            return {
	            //require: 'ngModel',
                templateUrl: '/backend/resultadopeticion/templateresultados?name=itemsimple.twig',
		          scope: {
                  //ngModel : '=',
                  peticion: '=',
                  categoria: '=',
                  item: '=',
                  rc: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.generalLab = GenerallabService;
		            	//console.log(" simple res");
                        if(angular.isDefined(scope.categoria)){
                           scope.$watch('item.resultado.resultado',function(newvalue,oldvalue){
                               if(newvalue!=oldvalue){
                                   scope.generalLab.getInterpretacionesCategoria(scope.peticion,scope.categoria,true)
                               }
                              //console.log("resultado cambiando");
                           },true)
                       }
			        });
		        }
          }
      }
})();